import {
	Directive,
	ElementRef,
	HostBinding,
	OnDestroy,
	OnInit,
} from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import ProjectsRepository from '~modules/project/store/projects/projects.repository';

@Directive({
	selector: '[appLockGuard]',
})
export class LockGuardDirective implements OnInit, OnDestroy {
	@HostBinding('class.is-locked') isLocked = false;

	private destroy$ = new Subject<void>();

	private clickHandler = (event: Event) => {
		if (this.isLocked) {
			event.stopImmediatePropagation();
			event.preventDefault();
			this.projectsRepository.triggerLockGlow();
		}
	};

	constructor(
		private readonly el: ElementRef,
		private readonly projectsRepository: ProjectsRepository
	) {}

	public ngOnInit(): void {
		this.projectsRepository.activeProjectLockedForUser$
			.pipe(takeUntil(this.destroy$))
			.subscribe((locked) => {
				this.isLocked = locked;
			});

		this.el.nativeElement.addEventListener('click', this.clickHandler, { capture: true });
	}

	public ngOnDestroy(): void {
		this.destroy$.next();
		this.destroy$.complete();
		this.el.nativeElement.removeEventListener('click', this.clickHandler, { capture: true });
	}
}